/**
 * ヘッダーのモバイルメニューと言語切り替えの制御
 */

(function() {
    'use strict';

    /**
     * ヘッダー機能の初期化
     */
    function initHeader() {
        // ハンバーガーメニューの制御
        const menuToggle = document.querySelector('.mobile-menu-toggle');
        const mobileNav = document.querySelector('.mobile-nav');
        const mobileNavClose = document.querySelector('.mobile-nav-close');

        // メニューを閉じる関数
        function closeMobileMenu() {
            if (menuToggle && mobileNav && mobileNavClose) {
                menuToggle.setAttribute('aria-expanded', 'false');
                mobileNavClose.setAttribute('aria-expanded', 'false');
                mobileNav.classList.remove('active');
                document.body.style.overflow = '';
            }
        }

        // メニューを開く関数
        function openMobileMenu() {
            if (menuToggle && mobileNav && mobileNavClose) {
                menuToggle.setAttribute('aria-expanded', 'true');
                mobileNavClose.setAttribute('aria-expanded', 'true');
                mobileNav.classList.add('active');
                document.body.style.overflow = 'hidden';
            }
        }

        if (menuToggle && mobileNav && mobileNavClose) {
            menuToggle.addEventListener('click', function() {
                const isExpanded = menuToggle.getAttribute('aria-expanded') === 'true';
                
                if (!isExpanded) {
                    openMobileMenu();
                } else {
                    closeMobileMenu();
                }
            });
        }

        // メニュー内の×ボタンで閉じる
        if (mobileNavClose && mobileNav) {
            mobileNavClose.addEventListener('click', function() {
                closeMobileMenu();
            });
        }

        // メニューリンクをクリックしたらメニューを閉じる
        if (mobileNav) {
            const menuLinks = mobileNav.querySelectorAll('a');
            menuLinks.forEach(function(link) {
                link.addEventListener('click', function() {
                    closeMobileMenu();
                });
            });
        }

        // ESCキーでメニューを閉じる
        document.addEventListener('keydown', function(e) {
            if (e.key === 'Escape' && mobileNav && mobileNav.classList.contains('active')) {
                closeMobileMenu();
                if (menuToggle) {
                    menuToggle.focus();
                }
            }
        });

        // メニュー外をクリックしたら閉じる
        document.addEventListener('click', function(e) {
            if (mobileNav && mobileNav.classList.contains('active') && 
                !mobileNav.contains(e.target) && 
                menuToggle && !menuToggle.contains(e.target)) {
                closeMobileMenu();
            }
        });

        // ============================================
        // デスクトップ用ドロップダウン言語切り替え（ホバーのみ）
        // ============================================
        
        const languageDropdown = document.querySelector('.language-switcher-dropdown');
        const languageButton = document.querySelector('.language-dropdown-button');
        const languageMenu = document.querySelector('.language-dropdown-menu');
        
        if (languageDropdown && languageButton && languageMenu) {
            let hoverTimeout = null; // ホバー時のタイムアウト
            
            // ドロップダウンを開く関数
            function openDropdown() {
                languageDropdown.classList.add('is-open');
                languageButton.setAttribute('aria-expanded', 'true');
            }
            
            // ドロップダウンを閉じる関数
            function closeDropdown() {
                languageDropdown.classList.remove('is-open');
                languageButton.setAttribute('aria-expanded', 'false');
            }
            
            // ホバー時の開閉処理
            languageDropdown.addEventListener('mouseenter', function() {
                if (hoverTimeout) {
                    clearTimeout(hoverTimeout);
                    hoverTimeout = null;
                }
                openDropdown();
            });
            
            languageDropdown.addEventListener('mouseleave', function() {
                hoverTimeout = setTimeout(function() {
                    closeDropdown();
                }, 100); // 少し遅延を入れて、マウスがメニューに移動する時間を確保
            });
        }
    }

    // DOMContentLoadedで確実に実行
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initHeader);
    } else {
        initHeader();
    }
})();


